import React from 'react';

export const OtherOrganizationIcon = ({ stroke = '#047857', width, height, className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M13.1892 14.0733C13.1892 12.5916 11.1871 11.3907 8.71821 11.3907C6.24932 11.3907 4.24721 12.5916 4.24721 14.0733M0.67041 11.3907C0.67041 10.2908 1.77385 9.34563 3.35301 8.93161M3.35301 5.34229C2.82749 4.86671 2.51153 4.20248 2.47416 3.4947C2.43679 2.78692 2.68104 2.09311 3.15357 1.56483C3.62609 1.03655 4.28847 0.71674 4.99602 0.675257C5.70358 0.633774 6.39879 0.873991 6.92981 1.34343M8.71821 8.70806C8.00674 8.70806 7.32441 8.42543 6.82132 7.92235C6.31824 7.41926 6.03561 6.73693 6.03561 6.02546C6.03561 5.31399 6.31824 4.63166 6.82132 4.12858C7.32441 3.62549 8.00674 3.34286 8.71821 3.34286C9.42968 3.34286 10.112 3.62549 10.6151 4.12858C11.1182 4.63166 11.4008 5.31399 11.4008 6.02546C11.4008 6.73693 11.1182 7.41926 10.6151 7.92235C10.112 8.42543 9.42968 8.70806 8.71821 8.70806Z"
                stroke={stroke}
                strokeWidth="1.3413"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};